<template>
    <v-container>
        <ModuleBar title="ADMINISTRAR NOMINA" icon="mdi-credit-card-settings-outline" />



        <v-card outlined class="mt-10">
            <v-card-text>
                <!-- <v-row>
                    <v-col>
                        <v-text-field label="Buscar nomina" v-model="argSearchPayroll" @keyup.enter="searchPayroll" />
                    </v-col>
                </v-row> -->
                <v-row v-if="loadingSearch">
                    <v-col class=" mt-10 d-flex justify-center">
                        <v-progress-circular indeterminate size="60" width="2" color="primary" />
                    </v-col>
                </v-row>
                <v-list v-if="payrolls">
                    <v-list-item-group color="primary">
                        <template v-for="payroll, key in payrolls">
                            <v-list-item :key="key" v-if="payrolls" @click="openDialogPayroll(payroll, 'edit')">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{payroll.employees.find(x => x.is_lider == 1).names}} /
                                        {{payroll.employees.find(x => x.is_lider == 1).last_names}} /
                                        {{payroll.employees.find(x => x.is_lider == 1).avatar}}
                                    </v-list-item-title>
                                    <v-list-item-subtitle>{{ payroll.location.name }}</v-list-item-subtitle>
                                    <v-list-item-subtitle>MONTO DE GASTO: {{
                                        payroll.amount_bill }}</v-list-item-subtitle>
                                    <v-list-item-subtitle>CANTIDAD DE EMPLEADOS: {{ payroll.employees.length ?
                                        payroll.employees.length : 0 }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider :key="`key${key}`" v-if="key != payrolls.length - 1" />
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card-text>
        </v-card>

        <v-dialog width="1000" v-model="dialogPayroll" persistent>
            <v-card>
                <v-card-text>
                    <payroll-form :payroll="payroll" title="EDITAR NOMINA" schema="edit" :click="click"
                        @closeDialogPayroll="closeDialogPayroll" />
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ModuleBar from '../../components/General/ModuleBar.vue';
import PayrollForm from "../../components/Forms/payrollForm.vue";

export default {

    components: { ModuleBar, PayrollForm },

    beforeMount() {
        this.search();
    },

    data() {
        return {
            argSearchPayroll: "",
            dialogPayroll: false,
            isSearch: false,
            loadingSearch: false,
            params: "",
            payrolls: null,
            payroll: null,
            click: 0,
        };
    },
    methods: {
        search() {
            this.payrolls = null;
            this.loadingSearch = true;
            this.isSearch = true;

            setTimeout(() => {
                this.$store.dispatch("payrollsFindAction").then((res) => {

                    this.payrolls = res;
                    this.loadingSearch = false;
                    this.isSearch = false;
                }).catch(() => {
                    this.loadingSearch = false;
                    this.isSearch = false;
                })
            }, 500);
        },

        openDialogPayroll(payroll, schema) {
            this.schema = schema;
            this.dialogPayroll = true;
            this.click++;
            this.payroll = payroll;
        },

        closeDialogPayroll(payload) {
            this.dialogPayroll = false;
            this.payroll = null;

            if (payload.action == 'delete') {
                let index = this.payrolls.findIndex((x) => x.id == payload.id);
                if (index >= 0) {
                    this.payrolls.splice(index, 1)
                    if (this.payrolls.length == 0) {
                        this.payrolls = null;
                    }
                }
            }
            else if (payload.action == "edit") {
                let index = this.payrolls.findIndex((x) => x.id == payload.id);
                if (index >= 0) {
                    this.payrolls[index].location_id = payload.location_id;
                    this.payrolls[index].location = payload.location;
                    this.payrolls[index].amount_bill = payload.amount_bill;
                    this.payrolls[index].description = payload.description;
                    this.payrolls[index].employees = payload.employees;

                }
            }
        },

        //sin trerminar
        searchPayroll() {
            this.loadingSearch = true;

            this.payrolls.forEach(element => {
                console.log(element.employees);

                let filter_ = element.employess.filter((x) =>
                    x.names.toLowerCase().includes(this.argSearchPayroll.toLowerCase()) ||
                    x.last_names.toLowerCase().includes(this.argSearchPayroll.toLowerCase()) ||
                    x.avatar.toLowerCase().includes(this.argSearchPayroll.toLowerCase())
                );

                console.log(filter_);
            });




        }
    },
}
</script>